import { useMutation } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { BOEScenario } from '../../../types';
import { BOESlideoutFormValues } from '../types';
import { prepareBackOfEnvelopePayload } from '../helpers';

export const useCalculateBackOfEnvelope = () => useMutation({
    mutationFn: async (values: BOESlideoutFormValues): Promise<BOEScenario> => {
        const payload = prepareBackOfEnvelopePayload(values);

        const response = await axiosInstance.post<BOEScenario>(
            API_ENDPOINTS.BACK_OF_ENVELOPE_CALCULATE,
            payload,
        );

        return response.data;
    },
});
